__turbopack_context__.v({
  "accessColumn": "AppsTable-module__tb1FYW__accessColumn",
  "appTagColumn": "AppsTable-module__tb1FYW__appTagColumn",
  "appsTable": "AppsTable-module__tb1FYW__appsTable",
  "checkAppConnectionsColumn": "AppsTable-module__tb1FYW__checkAppConnectionsColumn",
  "connectionsCountColumn": "AppsTable-module__tb1FYW__connectionsCountColumn",
  "countColumn": "AppsTable-module__tb1FYW__countColumn",
});
